/**
 * 物业管理模块翻译 - 中文
 * 包含：工单管理
 */
export default {
  property: {
    // 工单管理
    workorder: {
      title: '工单管理',
      // 统计卡片
      statPending: '待派单',
      statProcessing: '处理中',
      statCompleted: '已完成',
      statOverdue: '已超时',
      statTodayCreated: '今日新建',
      statTodayCompleted: '今日完成',
      statUrgent: '紧急工单',
      // 搜索表单
      keyword: '关键字',
      keywordPlaceholder: '工单号/标题',
      orderType: '工单类型',
      priority: '优先级',
      status: '工单状态',
      assignedTo: '处理人',
      startTime: '开始时间',
      endTime: '结束时间',
      hideSearch: '收起搜索',
      showSearch: '展开搜索',
      // 工单类型
      typeRepair: '报修',
      typeComplaint: '投诉',
      typeConsult: '咨询',
      typeInspection: '巡检',
      typeMaintenance: '维保',
      typeOther: '其他',
      // 优先级
      priorityUrgent: '紧急',
      priorityHigh: '高',
      priorityNormal: '普通',
      priorityLow: '低',
      // 工单状态
      statusPending: '待派单',
      statusAssigned: '已派单',
      statusProcessing: '处理中',
      statusCompleted: '已完成',
      statusVerified: '已验收',
      statusClosed: '已关闭',
      statusSuspended: '已挂起',
      statusPool: '抢单池',
      statusPendingApproval: '审批中',
      // 操作按钮
      createOrder: '新建工单',
      assign: '派单',
      autoAssign: '自动派单',
      putToPool: '放入抢单池',
      accept: '接单',
      addLog: '添加记录',
      complete: '完成处理',
      verify: '验收',
      closeOrder: '关闭',
      transfer: '转单',
      suspend: '挂起',
      resume: '恢复',
      urge: '催办',
      claim: '认领',
      submitApproval: '提交审批',
      // 表格列
      orderNo: '工单号',
      orderTitle: '工单标题',
      merchantName: '商户名称',
      shopName: '资产名称',
      assignedName: '处理人',
      creatorName: '创建人',
      deadline: '截止时间',
      createTime: '创建时间',
      source: '来源',
      // 来源
      sourceSystem: '后台创建',
      sourceMerchant: '商户提报',
      sourcePublic: '顾客扫码',
      sourceInspection: '巡检生成',
      // 表单
      formTitle: '工单标题',
      formTitlePlaceholder: '请输入工单标题',
      formTitleRequired: '请输入工单标题',
      formType: '工单类型',
      formTypeRequired: '请选择工单类型',
      formPriority: '优先级',
      formDescription: '问题描述',
      formDescriptionPlaceholder: '请详细描述问题情况',
      formMerchant: '关联商户',
      formShop: '关联铺位',
      formDeadline: '截止时间',
      formImages: '现场照片',
      // 报修扩展
      repairType: '报修分类',
      repairTypeElectric: '电气',
      repairTypePlumbing: '管道',
      repairTypeHvac: '暖通',
      repairTypeElevator: '电梯',
      repairTypeFire: '消防',
      repairTypeSecurity: '安防',
      repairTypeCleaning: '保洁',
      repairTypeOther: '其他',
      faultLocation: '故障位置',
      faultLocationPlaceholder: '请输入具体故障位置',
      faultDescription: '故障描述',
      faultDescriptionPlaceholder: '请描述故障具体情况',
      // 派单对话框
      dispatchTitle: '工单派单',
      dispatchDept: '指派部门',
      dispatchHandler: '指派处理人',
      dispatchHandlerRequired: '请选择处理人',
      dispatchRemark: '派单备注',
      // 转单对话框
      transferTitle: '转单',
      transferHandler: '转给处理人',
      transferHandlerRequired: '请选择处理人',
      transferRemark: '转单原因',
      // 处理记录
      processTitle: '添加处理记录',
      processContent: '处理内容',
      processContentRequired: '请输入处理内容',
      processContentPlaceholder: '请描述处理过程',
      processImages: '处理照片',
      // 完成处理
      completeTitle: '完成处理',
      completeContent: '处理结果',
      completeContentPlaceholder: '请描述最终处理结果',
      completeCost: '维修费用',
      // 验收
      verifyTitle: '工单验收',
      verifyPassed: '验收通过',
      verifyRejected: '验收驳回',
      verifyResult: '验收结果',
      verifyResultRequired: '请选择验收结果',
      verifyComment: '验收意见',
      verifyCommentPlaceholder: '请输入验收意见',
      verifyRating: '满意度评分',
      // 挂起
      suspendTitle: '挂起工单',
      suspendRemark: '挂起原因',
      suspendRemarkPlaceholder: '请输入挂起原因',
      // 详情面板
      detailTitle: '工单详情',
      basicInfo: '基本信息',
      repairInfo: '报修信息',
      processTimeline: '处理时间线',
      timelineCreated: '创建工单',
      timelineAssigned: '派单',
      timelineAccepted: '接单',
      timelineProcess: '处理记录',
      timelineCompleted: '完成处理',
      timelineVerified: '验收',
      timelineClosed: '关闭',
      timelineSuspended: '挂起',
      timelineResumed: '恢复',
      timelineTransferred: '转单',
      timelineUrged: '催办',
      timelineClaimed: '认领',
      // 确认消息
      confirmDelete: '确定要删除该工单吗？',
      confirmAccept: '确定接单吗？',
      confirmComplete: '确定完成处理吗？',
      confirmClose: '确定关闭该工单吗？关闭后无法重新打开。',
      forceCloseRemarkPlaceholder: '请输入关闭原因（选填）',
      confirmResume: '确定恢复该工单吗？',
      confirmUrge: '确定催办该工单吗？',
      confirmClaim: '确定认领该工单吗？',
      confirmAutoAssign: '确定自动派单吗？系统将按负载均衡策略分配处理人。',
      confirmPutToPool: '确定放入抢单池吗？',
      confirmSubmitApproval: '确定提交审批吗？',
    },
  },
}
